import { Footer2022, Intro2022 } from './components';
import { use2022Page } from './shared';

const videos = [
  ['https://youtu.be/atCC8QdiTaw', 'Event Highlight'],
  ['https://youtu.be/EoeIf0m9FCM', 'Message from Co-organiser: Cyberport'],
  ['https://youtu.be/0RW5CSNXqVI', 'Message from Strategic Partner: KPMG China'],
  ['https://youtu.be/nBl6u1KnWH4', 'Message from Strategic Partner: Smart City Consortium'],
  ['https://youtu.be/pTDkHORF2Ic', 'Message from Head of Judge: Dr. Winnie Tang, MH, JP'],
  ['https://youtu.be/-UxHpCqxCoc', 'Message from Awardee: Alpine Intelligent Medical Corporation Limited'],
  ['https://youtu.be/hkJ5vuM5XWc', 'Message from Awardee: ZhenHub Technologies Ltd.'],
] as const;

const ytImg = (url: string) => `https://img.youtube.com/vi/${url.split('/').pop()}/maxresdefault.jpg`;

const HighlightsVideo2022 = () => {
  use2022Page({ cate: 'highlightsVideo', lang: 'en', title: 'Smart Living Partnership Awards 2022 - Highlights Videos' });
  return (
    <div className="slpa2022-root">
      <Intro2022 lang="en" />
      <section id="LeadIn"><div className="wave_bg"><img src="/2022/images/judgebg-01.png" alt="" /></div></section>
      <section id="Highlights"><div className="Highlights_info"><div className="Highlights_Title">HIGHLIGHTS</div><div className="Highlights_TitleLine"><div className="Highlights_TitleLineDot"><img src="/2022/images/linedot.png" alt="" /></div></div><div className="Highlights_Table_Video"><div className="Highlights_Video_Photos"><a href="/2022/highlights.php"><p>Photos</p></a></div><div className="Highlights_Video_Videos"><a href="/2022/highlightsVideo.php"><p>Videos</p></a></div><div className="Highlights_Video_Articles"><a href="https://www.etnet.com.hk/www/tc/news/topic_news_category.php?category=smartlivingawards" target="_blank" rel="noreferrer"><p>Articles</p></a></div></div><div className="Highlights_Video_Table">{videos.map(([url,title]) => <div className="Highlights_Video_VideoBox" key={url}><div className="Highlights_Video_VideoBox_Video"><a href={url} target="_blank" rel="noreferrer"><img src={ytImg(url)} alt="" /></a><p>{title}</p></div></div>)}<div className="Highlights_Video_VideoBox_blank"></div></div></div></section>
      <Footer2022 lang="en" />
    </div>
  );
};

export default HighlightsVideo2022;

